import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './ProfileAvatar.css';
import { Skeleton, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { getAvatarPlaceholder } from 'utils/avatarUtils';

interface Props {
  profilePictureUri?: string;
  flagPictureUri?: string;
  isLoading?: boolean;
  username?: string;
}

export const ProfileAvatar = ({
  profilePictureUri,
  flagPictureUri,
  isLoading,
  username,
}: Props) => {
  const theme = useTheme();
  
  const avatarPlaceholder = useMemo(() => {
    return getAvatarPlaceholder(username);
  }, [username]);

  if (isLoading) {
    return (
      <Skeleton
        variant="circular"
        sx={{
          backgroundColor: theme.colors.grey,
        }}
        width={37}
        height={37}
      />
    );
  }

  return (
    <div className="profile-avatar">
      {profilePictureUri ? (
        <div className="profile-avatar-user-picture">
          <img
            src={profilePictureUri}
            alt="profile-avatar"
          />
        </div>
      ) : avatarPlaceholder ? (
        <div 
          className="profile-avatar-user-picture profile-avatar-placeholder"
          style={{ backgroundColor: avatarPlaceholder.color }}
        >
          <span className="profile-avatar-letter">
            {avatarPlaceholder.letter}
          </span>
        </div>
      ) : (
        <div className="profile-avatar-user-picture">
          <FontAwesomeIcon icon={'user'} color={theme.colors.white} />
        </div>
      )}
      {flagPictureUri && (
        <img
          className="profile-avatar-user-country-flag"
          src={flagPictureUri}
          alt="profile-country-flag"
        />
      )}
    </div>
  );
};
